import React from "react";
import { Link } from "react-router-dom";
import AppBackIcon from "./AppBackIcon";

/**
 * Shared back control — icon-only button or link with optional label.
 * Use `to` for navigation links, `onClick` for history/custom actions.
 */
const AppBackControl = ({
  to,
  onClick,
  label,
  variant = "icon",
  iconSize = 18,
  className = "",
  "aria-label": ariaLabel,
}) => {
  const isLink = variant === "link";
  const cls = [isLink ? "app-back-link" : "app-back-btn", className].filter(Boolean).join(" ");
  const a11yLabel =
    ariaLabel || (typeof label === "string" ? label : undefined) || "Go back";

  const content = (
    <>
      <AppBackIcon size={iconSize} />
      {isLink && label ? <span className="app-back-link-label">{label}</span> : null}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} aria-label={a11yLabel}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={cls} aria-label={a11yLabel}>
      {content}
    </button>
  );
};

export default AppBackControl;
